import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Fieldset from "../../../../Components/Common/Fieldset/Fieldset";
import {
  getAllProductVariant,
  getProductAttributes,
  readData,
} from "../OrderService";
import {
  setDoctorCategory,
  setProductVariantModalState,
  setSelectedAttributes,
} from "../../../../slices/orders/orderSlice";
import "../Order.scss";
import { useEffect } from "react";
import { formatAmount } from "../../../../Utils/CommonUtils";
import { useParams } from "react-router-dom";

function ProductAttributesModal({
  show,
  onHide,
  selectedProductEntityId,
  mode,
}) {
  const dispatch = useDispatch();
  const productAttributeData = useSelector(
    (state) => state.order.productAttributeData
  );
  const productVariantModalState = useSelector(
    (state) => state.order.productVariantModalState
  );
  const productVariant = useSelector(
    (state) => state.order.selectedOrders.productVariant
  );
  const { id } = useParams();
  const doctorCategory = useSelector((state) => state.order.doctorCategory);
  const formState = useSelector((state) => state.common.formRendererState);
  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );

  const displayedAttributes = new Set();
  const displayedAddOns = new Set();

  const productAttributesList = productAttributeData?.flatMap(
    (product) => product.product_attributes_list || []
  );
  const [apiSuccess, setApiSuccess] = useState(false);

  const [selectedOem, setSelectedOem] = useState(null);
  const [selectedPremium, setSelectedPremium] = useState(null);
  const [doctorCategoryValue, setDoctorCategoryValue] = useState("");
  const handleOemChange = (code, attributeMap, finalPremium, coverAmount) => {
    const selectedOption = {
      value: code,
      variant_json: attributeMap,
      finalPremium: finalPremium,
      coverAmount: coverAmount,
    };
    setSelectedOem(selectedOption);
    dispatch(
      setProductVariantModalState({
        ...productVariantModalState,
        oem: code,
        variant: selectedOption.variant_json,
        finalPremium: selectedOption.finalPremium,
        coverAmount: selectedOption.coverAmount,
      })
    );
  };
  const addOnsList =
    productAttributeData?.flatMap(
      (product) => product.product_addon_list || []
    ) || [];

  const [errors, setErrors] = useState({});

  // const handleAttributeChange = (attribute_key, selectedOption) => {
  //   let value = selectedOption ? selectedOption.value : null;

  //   // Special case for 'cover_amount' to format the value as "value|value"
  //   // if (attribute_key === "cover" && value) {
  //   //   value = `${value}|${value}`;
  //   // }

  //   if (attribute_key === "tenure") {
  //     value = "1 year";
  //   }

  //   dispatch(
  //     setProductVariantModalState({
  //       ...productVariantModalState,
  //       [attribute_key]: value,
  //     })
  //   );

  //   if (
  //     (attribute_key === "qualification" &&
  //       ((detailsData?.product_id && selectedOption?.value) ||
  //         (formState?.product_id && selectedOption?.value))) ||
  //     productVariantModalState.qualification
  //   ) {
  //     const productId = detailsData?.productid || formState?.product_id; // Use details.productid if available, otherwise fall back to formState.product_id
  //     const body = {
  //       qualification:
  //         selectedOption.value || productVariantModalState.qualification,
  //     };

  //     getDoctorCategory(productId, body);
  //     dispatch(
  //       setProductVariantModalState({
  //         ...productVariantModalState,
  //         doctor_category: value,
  //       })
  //     );
  //   }
  // };

  const handleAttributeChange = (attribute_key, selectedOption) => {
    let value = selectedOption ? selectedOption.value : null;

    if (attribute_key === "tenure") {
      value = "1 year";
    }

    const updatedState = {
      ...productVariantModalState,
      [attribute_key]: value,
    };

    if (
      attribute_key === "qualification" &&
      (detailsData?.product_id || formState?.product_id) &&
      selectedOption?.value
    ) {
      const productId = detailsData?.productid || formState?.product_id;
      const body = { qualification: selectedOption.value };

      // getDoctorCategory(productId, body);

      updatedState.doctor_category = value;
    }

    dispatch(setProductVariantModalState(updatedState));
  };

  const handleNumberChange = (attribute_key, selectedOption) => {
    let value = selectedOption;

    dispatch(
      setProductVariantModalState({
        ...productVariantModalState,
        [attribute_key]: value,
      })
    );
  };

  useEffect(() => {
    if (doctorCategory?.attribute_lov_label) {
      setDoctorCategoryValue(doctorCategory.attribute_lov_label);
      dispatch(
        setProductVariantModalState({
          ...productVariantModalState,
          doctor_category: doctorCategory.default_values,
        })
      );
    }
  }, [doctorCategory]);

  useEffect(() => {
    if (!productVariantModalState.tenure) {
      dispatch(
        setProductVariantModalState({
          ...productVariantModalState,
          tenure: "1 year",
        })
      );
    }
  }, [dispatch, productVariantModalState]);

  const handleAddOnChange = (event) => {
    const { value, checked } = event.target;
    dispatch(
      setProductVariantModalState({
        ...productVariantModalState,
        [value]: checked ? "yes" : "no",
      })
    );
  };
  const validateFields = () => {
    const newErrors = {};

    productAttributesList.forEach((attribute) => {
      if (attribute.required) {
        if (attribute.attribute_key === "doctor_category") {
          if (
            !productVariantModalState.qualification &&
            !productVariantModalState[attribute.attribute_key]
          ) {
            newErrors[attribute.attribute_key] = "This field is required.";
          }
        } else if (!productVariantModalState[attribute.attribute_key]) {
          newErrors[attribute.attribute_key] = "This field is required.";
        }
      }
    });

    if (!productVariantModalState.oem) {
      newErrors.oem = "This field is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleGetCode = () => {
    const isValid = validateFields();

    // if (isValid) {
    const transformedPayload = Object.keys(productVariantModalState).reduce(
      (acc, key) => {
        const selectedOption = productVariantModalState[key];

        if (key === "cover") {
          const value = String(selectedOption);
          acc[key] = `${value}|${value}`;
        } else if (
          selectedOption &&
          typeof selectedOption === "object" &&
          selectedOption.value
        ) {
          acc[key] = selectedOption.value;
        } else {
          acc[key] = selectedOption;
        }

        return acc;
      },
      {}
    );

    if (doctorCategory?.default_values) {
      transformedPayload.doctor_category = doctorCategory.default_values;
    }
    dispatch(setSelectedAttributes(transformedPayload));
    getAllProductVariant(formState.product_id, transformedPayload, onHide);
    setApiSuccess(true);
  };

  const handleSave = () => {
    onHide();
    // dispatch(setProductVariantModalState({ ...productVariantModalState, variant: null }));
    if (id) {
      dispatch(
        setProductVariantModalState({
          ...productVariantModalState,
          variant: null,
        })
      );
    }
  };

  useEffect(() => {
    if (id) {
      readData(id, "ODR");
      // dispatch(
      //   setProductVariantModalState(detailsData.variant_json)
      // );
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      handleGetCode();
    }
  }, [id, productVariantModalState.oem, productVariantModalState.tenure]);
    
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={onHide}
      size="lg"
    >
      <Form className="tablelist-form">
        <Modal.Header className="p-3 bg-info-subtle" closeButton>
          Attributes
        </Modal.Header>
        <Modal.Body className="modal-body">
          <Row className="g-3">
            {productAttributesList?.length > 0 && (
              <Col lg={12}>
                <div className="attributes-container">
                  <Row>
                    <div className="attributes-header">Attributes</div>
                    {productAttributesList.map((attribute, index) => {
                      if (displayedAttributes.has(attribute.name)) {
                        return null;
                      }
                      displayedAttributes.add(attribute.name);
                      const isRequired = attribute.is_required;
                      return (
                        <Col xs={6} key={index}>
                          <div className="attributes">
                            <Form.Label htmlFor={`dropdown-${index}`}>
                              {attribute.name}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            {attribute.attribute_key === "doctor_category" ? (
                              <Form.Control
                                type="text"
                                id={`doctor-category-${index}`}
                                placeholder={`Enter`}
                                value={doctorCategory.attribute_lov_label}
                                onChange={(e) =>
                                  handleAttributeChange(
                                    attribute.attribute_key,
                                    e.target.value
                                  )
                                }
                                isInvalid={!!errors[attribute.attribute_key]}
                              />
                            ) : attribute.element_type === "dropdown" ||
                              attribute.element_type === "range" ||
                              attribute.element_type === "badge" ? (
                              <Select
                                id={`attribute-${index}`}
                                options={attribute.product_attribute_lov.map(
                                  (option) => ({
                                    value: option.attribute_value,
                                    label: option.name,
                                  })
                                )}
                                onChange={(selectedOption) =>
                                  handleAttributeChange(
                                    attribute.attribute_key,
                                    selectedOption
                                  )
                                }
                                className={
                                  errors[attribute.attribute_key]
                                    ? "is-invalid"
                                    : ""
                                }
                                value={
                                  productVariantModalState[
                                    attribute.attribute_key
                                  ]
                                    ? {
                                        value:
                                          productVariantModalState[
                                            attribute.attribute_key
                                          ],
                                        label:
                                          attribute.product_attribute_lov.find(
                                            (option) =>
                                              option.attribute_value ===
                                              productVariantModalState[
                                                attribute.attribute_key
                                              ]
                                          )?.name,
                                      }
                                    : null
                                }
                                // value={
                                //   productVariantModalState[
                                //     attribute.attribute_key
                                //   ]
                                //     ? {
                                //         value:
                                //           productVariantModalState[
                                //             attribute.attribute_key
                                //           ],
                                //         label:
                                //           attribute.product_attribute_lov.find(
                                //             (option) =>
                                //               option.attribute_value ===
                                //               productVariantModalState[
                                //                 attribute.attribute_key
                                //               ]
                                //           )?.name,
                                //       }
                                //     : null // Ensure null when no value is selected
                                // }
                              />
                            ) : attribute.element_type === "number" ||
                              attribute.element_type === "range_number" ? (
                              <Form.Control
                                type="number"
                                id={`number-${index}`}
                                placeholder={`Enter ${attribute.name}`}
                                value={
                                  productVariantModalState[
                                    attribute.attribute_key
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleNumberChange(
                                    attribute.attribute_key,
                                    Number(e.target.value)
                                  )
                                }
                                isInvalid={!!errors[attribute.attribute_key]}
                              />
                            ) : null}
                            {errors[attribute.attribute_key] && (
                              <Form.Control.Feedback type="invalid">
                                {errors[attribute.attribute_key]}
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Col>
                      );
                    })}

                    <div className="attributes-header">Add Ons</div>

                    <Col xs={12}>
                      <div className="attributes">
                        {addOnsList.map((addOn, index) => {
                          if (displayedAddOns.has(addOn.name)) {
                            return null;
                          }
                          displayedAddOns.add(addOn.name);

                          const isChecked =
                            productVariantModalState[addOn.name] === "yes";
                          return (
                            <div key={index}>
                              <Form.Check
                                type="checkbox"
                                id={`addon-${index}`}
                                label={addOn.label}
                                value={addOn.name}
                                onChange={handleAddOnChange}
                                checked={isChecked}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </Col>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button className="primary" onClick={handleGetCode}>
                        Get Quote
                      </Button>
                    </div>
                  </Row>
                  {apiSuccess && (
                    <Row>
                      <div className="attributes-header">Insurance Company</div>
                      {productVariant.content?.map((product, index) => {
                        return (
                          <div className="d-flex gap-5" key={index}>
                            {product.product_variants.map((oem, oemIndex) => {
                              if (oem.pspOem.type === "Product") {
                                return (
                                  <Form.Check
                                    key={`${index}`}
                                    type="radio"
                                    id={`oem-${index}`}
                                    label={oem.pspOem.name}
                                    value={oem.pspOem.name}
                                    checked={
                                      productVariantModalState &&
                                      productVariantModalState.oem ===
                                        oem.pspOem.code
                                    }
                                    onChange={() =>
                                      handleOemChange(
                                        oem.pspOem.code,
                                        product.attribute_map,
                                        product.final_premium,
                                        product.attribute_map.cover
                                      )
                                    }
                                  />
                                );
                              }
                            })}
                            <p>
                              Premium Amount -{" "}
                              {formatAmount(
                                product.final_premium,
                                null,
                                null,
                                "lakh"
                              )}
                            </p>
                          </div>
                        );
                      })}
                    </Row>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {productVariantModalState.variant && (
            <Button type="button" onClick={handleSave} disabled={!selectedOem}>
              {id ? "Save" : "Save"}
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ProductAttributesModal;
